import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StepPersonalInfo from './StepPersonalInfo';
import StepTracking from './StepTracking';
import ActiveAccount from './ActiveAccount';

function ProfileSetup() {
    const [currentStep, setCurrentStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState<number[]>([]);
    const [profileData, setProfileData] = useState<any>({});
    const [firstName, setFirstName] = useState<string>('')
    const [lastName, setLastName] = useState<string>('')
    const [birthday, setBirthday] = useState<string | string[] | undefined>();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is registered
        const registrationData = localStorage.getItem('registrationData');
        // if (!registrationData) {
        //     navigate('/sign-up');
        //     return;
        // }
        
        // const regData = JSON.parse(registrationData);
        // setProfileData({ email: regData.email });
    }, [navigate]);

    const profileSteps = [
        {
            component: <StepPersonalInfo 
                setCurrentStep={setCurrentStep}
                setProfileData={setProfileData}
                profileData={profileData}
                setCompletedSteps={setCompletedSteps}
                completedSteps={completedSteps}
                setFirstName={setFirstName}
                firstName={firstName}
                setLastName={setLastName}
                lastName={lastName}
                birthday={birthday}
                setBirthday={setBirthday}
            />
        },
        // {
        //     component: <StepEmail 
        //         setCurrentStep={setCurrentStep}
        //         profileData={profileData}
        //         setCompletedSteps={setCompletedSteps}
        //         completedSteps={completedSteps}
        //     />
        // },
        {
            component: <ActiveAccount
                setCurrentStep={setCurrentStep}
                profileData={profileData}
                navigate={navigate}
                setCompletedSteps={setCompletedSteps}
                completedSteps={completedSteps}
            />
        }
    ];

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-dark-900 to-yellow-900 relative overflow-hidden">
            <div className="fixed inset-0 w-full h-full">
                {/* <img 
                    src="/images/bg-step.jpg" 
                    alt="Background" 
                    className="object-cover w-full h-full opacity-20"
                /> */
                <video
					autoPlay
					loop
					muted
					playsInline
					className="w-full h-full object-cover opacity-20"
				>
					<source src="/video/new-bg-video.mp4" type="video/mp4" />
					{/* <source src="/video/bg-video.webm" type="video/webm" /> */}
					Your browser does not support the video tag.
				</video>}
                <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-transparent to-black/90"></div>
                
                <div className="absolute top-20 left-20 w-32 h-32 bg-blue-500/10 rounded-full blur-xl"></div>
                <div className="absolute bottom-20 right-20 w-48 h-48 bg-purple-500/10 rounded-full blur-xl"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-pink-500/5 rounded-full blur-2xl"></div>
            </div>

            <div className="relative z-10 flex items-center justify-center min-h-screen px-4 py-8">
                <div className="w-full max-w-7xl mx-auto flex items-center justify-center ">
                    <div className="md:w-[80%] lg:w-[60%] w-[100%] flex items-stretch gap-2 flex-col max-lg:items-center bg-white/5 backdrop-blur-lg border border-white/10 rounded-xl p-6 h-fit">
                        <div className="flex-1 w-full max-lg:w-full max-lg:max-w-md max-lg:order-1 flex-shrink-0">
                            <StepTracking 
                                currentStep={currentStep} 
                                completedSteps={completedSteps}
                            />
                        </div>

                        <div className="max-lg:order-2 w-full">
                            <p className='!text-white/50'>Step {currentStep + 1} of {profileSteps.length}</p>
                            <div className="overflow-hidden">
                                <div className="md:px-8 px-0">
                                    <div className="transition-all duration-300 ease-in-out">
                                        {profileSteps[currentStep]?.component}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfileSetup;
